export default {
    getNotes: state => state.notes,
    getActiveNote: state => state.activeNote,
    getNoteHistory: state => state.noteHistory,
    getTotalNotes: state => state.totalNotes,
    getTotalChanges: state => state.totalChanges,
}